<style scoped></style>

<template>
  <div style="height: 100%;display: flex;flex-direction: row;">
    <OutorderGroup mode="exec" @reload="detailKey++" style="width: 250px; height: unset; flex: unset;" @item-choose="item => chooseData = item" />
    <OutorderDetail :key="detailKey" v-if="chooseData" :outOrderGroupId="chooseData.id" style="flex: 1; width: 0;height: unset;margin-left: 0;padding: 0;" />
  </div>
</template>

<script>
import OutorderGroup from '../../../../components/goods/produce/outorder/group.vue'
import OutorderDetail from './index.vue'

export default {
  components: { OutorderGroup, OutorderDetail },
  data () {
    return {
      chooseData: null,
      detailKey: 0
    }
  }
}
</script>
